import React, { useCallback } from 'react';
import { CronofyOptions } from '../../../../../components/cronofy/CronofyOptions';
import { InterviewStage } from '../../../../../entities/applicant_tracking/InterviewStage';
import { EventSlot } from '../../../../../components/cronofy/CronofyDatePicker/EventSlot';
import ScheduleInterviewPage from '../index';
import { User } from '../../../../../entities/User';
import candidateSchedulingImage from '../../../../../images/candidate-experience-mailer-new-survey.png';
import { InterviewCandidateUser } from '../../../../../entities/applicant_tracking/InterviewCandidateUser';
import { InterviewCandidateUserService } from '../../../../../services/applicant_tracking/InterviewCandidateUserService';
import { VcsProvider } from '../../../../../enums/IntegrationProvider/VcsProvider';
import { appendCurrentRedirectUri } from '../../../../../utils/url';
import { addReturnTitle } from '../../../../../utils/applicant_tracking/actions/schedulingActions';
import { Candidate } from '../../../../../entities/applicant_tracking/Candidate';

interface PropTypes {
  cronofyDatePickerOptions: CronofyOptions;
  candidate: Candidate;
  applicationId: number;
  jobName: string;
  interviewCandidateUser: InterviewCandidateUser;
  organizer: User;
  interviewId: number;
  interviewerUsers: User[];
  interviewStage: InterviewStage;
  meetingProvider: VcsProvider;
  startDate: Date;
}

export default function SelfScheduleInterview(props: PropTypes) {
  const onConfirm = useCallback(async (eventSlot: EventSlot) => {
    try {
      await InterviewCandidateUserService.selfSchedule(
        props.interviewCandidateUser.secureId,
        eventSlot.slot.start,
        eventSlot.slot.end,
        eventSlot.tzid,
      );

      const path = appendCurrentRedirectUri(
        `/applicant_tracking/interview_candidate_users/${props.interviewCandidateUser.secureId}/schedule/success`,
      );

      window.location.href = addReturnTitle(path);
    } catch (e) {
      window.location.href = appendCurrentRedirectUri(
        '/applicant_tracking/interview_candidate_users/schedule/error',
      );
    }
  }, []);

  return (
    <ScheduleInterviewPage
      meetingOrganizer={props.organizer}
      applicationIds={[props.applicationId]}
      title={`Hi ${props.candidate.name}, welcome!`}
      description={
        'Here you can pick the time and self-schedule your interview.'
      }
      cronofyDatePickerOptions={props.cronofyDatePickerOptions}
      candidate={props.candidate}
      participants={props.interviewerUsers}
      interviewStage={props.interviewStage}
      meetingProviders={[]}
      meetingProvider={props.meetingProvider}
      durationMinutes={props.interviewCandidateUser.meetingDuration}
      onConfirm={onConfirm}
      customImage={candidateSchedulingImage}
      startDate={props.interviewCandidateUser.updatedAt}
      scheduleFromHours={props.interviewCandidateUser.scheduleFromHours}
      dateRange={props.interviewCandidateUser.dateRange}
      jobName={props.jobName}
      selfScheduleView={false}
      candidateView={true}
      allowChangingMeetingOrganizer={false}
      allowIgnoreParticipantCalendar={false}
    />
  );
}
